import React from "react"
import { has } from "lodash"

import VersionEntry from "./VersionEntry"
import AddNewBuildConfig from "./AddNewBuildConfig"

import { v4 as uuidv4 } from "uuid"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus, faSpinner } from "@fortawesome/free-solid-svg-icons"

class VersionForm extends React.Component {
    constructor() {
        super()
        this.pageSize = 10
        this.state = {
            buildConfigs: [],
            versionIsProdReleaseMap: {},
            isLoading: true,
            addNewConfig: false,
            version: "",
            versionError: "",
            versionNumber: "",
            versionNumberError: "",
            engineVersion: "",
            engineVersionError: "",
            page: 1,
            loadMore: true
        }
    }
    componentDidMount() {
        this.getBuildConfig(0)
    }
    getBuildConfig = (offset, refresh = false) => {
        fetch(`/api/data/project/${this.props.projectId}/appConfig/${this.props.appConfigId}/buildConfig/list?limit=${this.pageSize}&offset=${offset}`)
            .then(res => res.json())
            .then(data => {
                if (has(data, "error")) { throw data }
                var loadMore = true
                if (data.result.length < this.pageSize) {
                    loadMore = false
                }
                const versions = []
                for (const config of data.result) {
                    if (!this.state.versionIsProdReleaseMap[config.version]) {
                        versions.push(config.version);
                    }
                }
                if (versions.length > 0) {
                    this.getVersionIsProdRelease(versions);
                }
                this.setState(prevState => {
                    return {
                        buildConfigs: refresh === true
                            ? data.result.sort((a, b) => b.createdAt.localeCompare(a.createdAt))
                            : [...prevState.buildConfigs, ...data.result.sort((a, b) => b.createdAt.localeCompare(a.createdAt))],
                        isLoading: false,
                        addNewConfig: false,
                        loadMore: loadMore
                    }
                })
            })
            .catch(data => this.setState({ versionError: `Server: ${data.error}`, isLoading: false }))
    }
    getVersionIsProdRelease = (versions) => {
        fetch(`/api/data/project/${this.props.projectId}/getIsProdRelease?versions=${versions.join('-')}`)
            .then(res => res.json())
            .then(data => {
                if (has(data, "error")) { throw data }
                this.setState(prevState => {
                    for (const version of Object.keys(data)) {
                        prevState.versionIsProdReleaseMap[version] = data[version]
                    }
                    return {
                        versionIsProdReleaseMap: prevState.versionIsProdReleaseMap,
                    }
                })
            })
            .catch(data => this.setState({ versionError: `Server: ${data.error}`, isLoading: false }))
    }
    setIsProdRelease = (version, checked) => {
        fetch(`/api/data/project/${this.props.projectId}/setIsProdRelease?version=${version}&isProdRelease=${checked}`)
            .then(res => res.json())
            .then(data => {
                if (has(data, "error")) { throw data }
                this.setState(prevState => {
                    prevState.versionIsProdReleaseMap[version] = data.isProdRelease;
                    return {
                        versionIsProdReleaseMap: prevState.versionIsProdReleaseMap,
                    }
                })
            })
            .catch(data => this.setState({ versionError: `Server: ${data.error}`, isLoading: false }))
    }
    loadMoreConfigs = () => {
        this.setState(prevState => {
            return {
                page: prevState.page + 1,
                isLoading: true
            }
        }, () => this.getBuildConfig((this.state.page - 1) * this.pageSize))
    }
    addNewConfig = (e) => {
        e.preventDefault()
        this.setState({
            addNewConfig: true
        })
    }
    cancelNewConfig = (e) => {
        e.preventDefault()
        this.setState({
            addNewConfig: false,
        })
    }
    render() {
        const { isLoading, buildConfigs, addNewConfig, versionIsProdReleaseMap } = this.state
        const { projectId, appConfigId, appConfig } = this.props
        return (
            <form className="requestForm">
                {
                    addNewConfig === true
                    ? <AddNewBuildConfig cancelNewConfig={this.cancelNewConfig}
                        getBuildConfig={this.getBuildConfig} appConfigId={appConfigId} projectId={projectId} appConfig={appConfig} />
                    : <div className="buildConfigForm">
                        <button className="addBtn" onClick={this.addNewConfig}>
                            <FontAwesomeIcon icon={faPlus} /> New Build
                    </button>
                    </div>
                }
                <div className="formWrapper">
                    <div className="buildConfigForm">
                        <h5 className="col title">Id</h5>
                        <h5 className="col title">Created</h5>
                        <h5 className="col title">Version</h5>
                        <h5 className="col title">Engine</h5>
                        <h5 className="col title">Asset Packs</h5>
                        <h5 className="col title">Platform</h5>
                        <h5 className="col title">Status</h5>
                        <h5 className="col title">Separate Event Bundle</h5>
                        <h5 className="col title">Is Production Release</h5>
                    </div>
                    {buildConfigs.map(buildConfig => <VersionEntry setIsProdRelease={this.setIsProdRelease} versionIsProdReleaseMap={versionIsProdReleaseMap} projectId={projectId} buildConfig={buildConfig} key={uuidv4()} />)}
                    {isLoading
                        ? <div className="loading"><FontAwesomeIcon icon={faSpinner} spin /></div>
                        : null
                    }
                    {this.state.loadMore === true
                        ? <div className="buildConfigForm">
                            <a onClick={this.loadMoreConfigs}>Load more...</a>
                        </div>
                        : null}
                </div>
            </form>
        )
    }
}

export default VersionForm